import CardComponent from '@/components/CardComponent'

import ProfileList from '../ProfileList'

const ProfileHeader = ({ data, headerActions, onItemClick }) => {
  const userInfo = data?.userInfo
  const phone = userInfo?.phone
  const kycStatus = userInfo?.kycStatus
  const email = userInfo?.email

  const headerActionsItems = headerActions?.items
  const hasHeaderActions = Array.isArray(headerActionsItems) && headerActionsItems.length > 0

  const headerActionsData = hasHeaderActions
    ? {
        components: {
          items: headerActionsItems
        }
      }
    : null

  return (
    <CardComponent className='ew-mb-12'>
      <div className='ew-d-flex ew-flex-column'>
        <div className='ew-typography-large ew-fw-bold'>{data?.title}</div>

        {phone && kycStatus ? (
          <div className='ew-d-flex ew-align-items-center ew-typography-tiny ew-color-secondary ew-fw-regular'>
            <span>
              {phone} · {kycStatus.text}
            </span>
            {kycStatus.icon ? (
              <img
                alt={kycStatus.text ?? 'KYC Status'}
                className='ew-ml-4'
                height={16}
                src={kycStatus.icon}
                width={16}
              />
            ) : null}
          </div>
        ) : null}

        {email?.text ? (
          <div className='ew-d-flex ew-align-items-center ew-typography-tiny ew-color-secondary ew-fw-regular'>
            <span>{email.text}</span>
            {email.icon ? (
              <img
                alt={email.verified ? 'Email Verified' : 'Email Unverified'}
                className='ew-ml-4'
                height={16}
                src={email.icon}
                width={16}
              />
            ) : null}
          </div>
        ) : null}
      </div>

      {hasHeaderActions ? (
        <ProfileList data={headerActionsData} noCard onItemClick={onItemClick} />
      ) : null}
    </CardComponent>
  )
}

export default ProfileHeader
